export default {
  logo: "QuraniPiroz",
  info: "Audio Files Was Taken From:"
}